module.exports = __webpack_public_path__ + "img/img-b5e76183.3fc2b7e1.png";